import * as React from 'react';
import styles from './index.less';
import { Modal, Space } from 'antd';
import { ActivityDetailsPageModelState } from '@/models/activityDetailsPage';
import { connect } from 'dva';
import { ConnectState } from '@/models/connect';
import { FUtil, FI18n, FServiceAPI } from '@freelog/tools-lib';
import * as AHooks from 'ahooks';
import FSimpleBar from '@/components/FSimpleBar';

interface ActivityRuleProps {
  visible: boolean;
  // set_PickVisible: any;
  // activityDetailsPage: ActivityDetailsPageModelState;
  onCancel?: () => void;
}

// [
//
//   '67b5d5a01215040030f8f903',
//   '67b003891215040030f8b404',
//   // 第三期 插画
//   '67c573e11215040030f9bbc6',
//   '67c41dfa1215040030f9b0e9',
//   '67c41cd71215040030f9b090',
//   '67c41a951215040030f9b046',
//   '67c417921215040030f9aeca',
//   '67c572431215040030f9bb78',
//   '67c56f801215040030f9ba8c',
//   '67c502d11215040030f9b34f',
//   '67d659461215040030fa488b',
//   '676e96f20d411d002fc8fe65',
//   '676e97bb0d411d002fc8fec8',
//   '677742fb0d411d002fc9915f',
//   '67734d1f0d411d002fc94eb0',
//   '67734ce70d411d002fc94e69',
//   '67734bfe0d411d002fc94e15',
//   '67a49491652c70002f4dbe61',
//   '67ba7df91215040030f9236d',
//   '67b862181215040030f91f8b',
//   '67b862171215040030f91f71',

//   // 第三期 照片
//   '67d56dd31215040030fa42e8',
//   '67c1b9bc1215040030f9a152',
//   '67d28fd61215040030fa1901',
//   '679df3fb652c70002f4dab53',
//   '67d291411215040030fa199c',
// ]

//  连载漫画
const comic: string[] = [
  // 第三期
  // '67b5d5a01215040030f8f903', '67b003891215040030f8b404'

  // 第四期
  // '67e5ffb5144a1c002f8ea542',

  // 第五期
  '69323e4dad8c83002f4476c2'
];

// 插画
const illustration: string[] = [
  // 第三期
  // '67c573e11215040030f9bbc6',
  // '67c41dfa1215040030f9b0e9',
  // '67c41cd71215040030f9b090',
  // '67c41a951215040030f9b046',
  // '67c417921215040030f9aeca',
  // '67c572431215040030f9bb78',
  // '67c56f801215040030f9ba8c',
  // '67c502d11215040030f9b34f',
  // '67d659461215040030fa488b',
  // '676e96f20d411d002fc8fe65',
  // '676e97bb0d411d002fc8fec8',
  // '677742fb0d411d002fc9915f',
  // '67734d1f0d411d002fc94eb0',
  // '67734ce70d411d002fc94e69',
  // '67734bfe0d411d002fc94e15',
  // '67a49491652c70002f4dbe61',
  // '67ba7df91215040030f9236d',
  // '67b862181215040030f91f8b',
  // '67b862171215040030f91f71',

  // 第四期
  // '6850dc3ac654350030963a0a',
  // '6850dc3bc654350030963a22',
  // '6850dc3bc654350030963a3a',
  // '6850dc3bc654350030963a68',
  // '6850dc3bc654350030963a51',
  // '6850dc3cc654350030963aca',
  // '6850dc3cc654350030963ab1',
  // '6850dc3bc654350030963a9a',
  // '6850dc3bc654350030963a82',
  // '68731c2bc6543500309706da',
  // '68731babc65435003097067f',
  // '68710590c65435003097007e',
  // '68710533c65435003096ff99',
  // '687104a5c65435003096feb5',
  // '686f0fdfc65435003096ea16',
  // '686b9f56c65435003096dccb',
  // '6868a724c65435003096cfc8',
  // '6868a631c65435003096ceb9',
  // '687103cbc65435003096fe69',

  // 第五期
  '6907426f23328d002f20620f',
  '690743f923328d002f20632a',
  '690744a923328d002f2063b6',
  '6914473423328d002f20c131',
  '691f0bcf23328d002f2114f4',
  '6914473523328d002f20c1af',
  '6914473523328d002f20c198',
  '6914473523328d002f20c177',
  '693937a0ad8c83002f449725',
  '6939379fad8c83002f44970e',
  '6914473523328d002f20c149',
  '693569f5ad8c83002f44844f',
];

// 照片
const photo: string[] = [
  // 第三期
  // '67d56dd31215040030fa42e8',
  // '67c1b9bc1215040030f9a152',
  // '67d28fd61215040030fa1901',
  // '679df3fb652c70002f4dab53',
  // '67d291411215040030fa199c',

  // 第四期
  '688485ff991fb4002fdeae94',
  '688487ee991fb4002fdeb0cc',
];

// const pictures = [
//   '662cc44e12f79d002edab526',
//   '669cb46c228a3a0039721b03',
//   '668407bf130d17002e00ec91',
//   '66840823130d17002e00ecfc',
//   '665426d7e266bf002ece37da',
//   '6654269ae266bf002ece3754',
//   '66503bd0e266bf002ece2a36',
//   '664db7afe266bf002ece0df7',
//   '664e9f98e266bf002ece1238',
//   '66877fbb228a3a003971a1da',
// ];
// const audios = [
//   '662f0c8712f79d002edad986',
//   '662f0b4112f79d002edad7d6',
//   '662e044c12f79d002edac48c',
// ];

function ActivityRule({ visible, onCancel }: ActivityRuleProps) {
  const [resourceData, setResourceData] = React.useState<any[]>([]);
  // const [nodeData, setNodeData] = React.useState<any[]>([]);

  function goResource(id: string) {
    window.open(
      FUtil.Format.completeUrlByDomain('console') +
        FUtil.LinkTo.resourceDetails({
          resourceID: id,
        }),
    );
  }

  AHooks.useMount(async () => {
    const { data } = await FServiceAPI.Resource.batchInfo({
      resourceIds: [...comic, ...illustration, ...photo].join(','),
    });
    setResourceData(data);
  });

  return (
    <>
      <Modal
        open={visible}
        title={null}
        footer={null}
        width={1016}
        centered={true}
        style={{ borderRadius: 10, overflow: 'hidden' }}
        styles={{ content: { padding: 0 } }}
        onCancel={() => {
          onCancel?.();
        }}
      >
        <FSimpleBar height={'calc(100vh - 200px)'}>
          <div className={styles.pick}>
            <div className={styles.head}>编辑精选第四期获奖公示</div>
            <div className={styles.content}>
              <div className={styles.title}>
                <span>—————— 连载漫画 ——————</span>
              </div>
              <div className={styles.carContainer}>
                {resourceData
                  .filter((item) => comic.includes(item.resourceId))
                  .map((item, index: number, arr) => {
                    return (
                      <div
                        key={item.resourceId}
                        className={
                          styles.card +
                          ' ' +
                          (arr.length > 3 && index > 2 ? styles.marginT : '') +
                          ' ' +
                          ((index + 1) % 3 !== 0 && index !== arr.length - 1 ? styles.marginR : '')
                        }
                      >
                        <div className={styles.img} onClick={() => goResource(item.resourceId)}>
                          <img
                            src={
                              item.coverImages[0] || FUtil.Format.completeUrlByDomain('static') + '/static/default_cover.png'
                            }
                            fetchPriority={'low'}
                            loading={'lazy'}
                            alt=''
                          />
                        </div>
                        <div
                          className={styles.carTitle}
                          onClick={() => goResource(item.resourceId)}
                        >
                          {item.resourceTitle || item.resourceName.split('/')[1]}
                        </div>
                        <div className={styles.personInfo}>
                          <div className={styles.avatar}>
                            <img
                              src={FUtil.Domain.IMAGE_ORIGIN + `/avatar/${item.userId}`}
                              fetchPriority={'low'}
                              loading={'lazy'}
                              alt=''
                            />
                          </div>
                          <div className={styles.name}>{item.username}</div>
                          <div className={styles.reward}>奖励¥50</div>
                        </div>
                      </div>
                    );
                  })}
              </div>
              <div className={styles.title}>
                <span>—————— 插画 ——————</span>
              </div>
              <div className={styles.carContainer}>
                {resourceData
                  .filter((item) => illustration.includes(item.resourceId))
                  .map((item, index: number, arr) => {
                    return (
                      <div
                        key={item.resourceId}
                        className={
                          styles.card +
                          ' ' +
                          (arr.length > 3 && index > 2 ? styles.marginT : '') +
                          ' ' +
                          ((index + 1) % 3 !== 0 && index !== arr.length - 1 ? styles.marginR : '')
                        }
                      >
                        <div className={styles.img} onClick={() => goResource(item.resourceId)}>
                          <img
                            src={
                              item.coverImages[0] || FUtil.Format.completeUrlByDomain('static') + '/static/default_cover.png'
                            }
                            alt=''
                            fetchPriority={'low'}
                            loading={'lazy'}
                          />
                        </div>
                        <div
                          className={styles.carTitle}
                          onClick={() => goResource(item.resourceId)}
                        >
                          {item.resourceTitle || item.resourceName.split('/')[1]}
                        </div>
                        <div className={styles.personInfo}>
                          <div className={styles.avatar}>
                            <img
                              src={FUtil.Domain.IMAGE_ORIGIN + `/avatar/${item.userId}`}
                              fetchPriority={'low'}
                              loading={'lazy'}
                              alt=''
                            />
                          </div>
                          <div className={styles.name}>{item.username}</div>
                          <div className={styles.reward}>奖励¥20</div>
                        </div>
                      </div>
                    );
                  })}
              </div>

              <div className={styles.title}>
                <span>—————— 照片 ——————</span>
              </div>
              <div className={styles.carContainer}>
                {resourceData
                  .filter((item) => photo.includes(item.resourceId))
                  .map((item, index: number, arr) => {
                    return (
                      <div
                        key={item.resourceId}
                        className={
                          styles.card +
                          ' ' +
                          (arr.length > 3 && index > 2 ? styles.marginT : '') +
                          ' ' +
                          ((index + 1) % 3 !== 0 && index !== arr.length - 1 ? styles.marginR : '')
                        }
                      >
                        <div className={styles.img} onClick={() => goResource(item.resourceId)}>
                          <img
                            src={
                              item.coverImages[0] || FUtil.Format.completeUrlByDomain('static') + '/static/default_cover.png'
                            }
                            alt=''
                            fetchPriority={'low'}
                            loading={'lazy'}
                          />
                        </div>
                        <div
                          className={styles.carTitle}
                          onClick={() => goResource(item.resourceId)}
                        >
                          {item.resourceTitle || item.resourceName.split('/')[1]}
                        </div>
                        <div className={styles.personInfo}>
                          <div className={styles.avatar}>
                            <img
                              src={FUtil.Domain.IMAGE_ORIGIN + `/avatar/${item.userId}`}
                              fetchPriority={'low'}
                              loading={'lazy'}
                              alt=''
                            />
                          </div>
                          <div className={styles.name}>{item.username}</div>
                          <div className={styles.reward}>奖励¥20</div>
                        </div>
                      </div>
                    );
                  })}
              </div>
            </div>
            <div className={styles.foot}>
              <div className={styles.footText}>
                奖励将在结果公示期结束后，即在官方公布最终获奖名单后的15个工作日内，发放至获奖用户的Freelog账号名下
              </div>
            </div>
          </div>
        </FSimpleBar>
      </Modal>
    </>
  );
}

export default ActivityRule;
